import { TFunction } from 'i18next';

export const BATHROOM_PATH = '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/';

export const BATHROOM_LANDING_NAME = 'bathroom';

export const BATHROOM_ELEMENT_BLOCK = 'landingVannuyuKomnatu';

export const CATEGORY_ID = '934';

export const BATHROOM_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,d_photoiscoming.png,b_auto/fudzi/elbrus/images/landings/bathrooms-2';

export const getBathroomImageList = (t: TFunction) => [
  {
    ldSrcSet: `${BATHROOM_CDN_PATH}/header/1b-ld.jpg/1b-ld.jpg`,
    dSrcSet: `${BATHROOM_CDN_PATH}/header/1c-d.jpg/1c-d.jpg`,
    tSrcSet: `${BATHROOM_CDN_PATH}/header/1b-t.jpg/1b-t.jpg`,
    mSrcSet: `${BATHROOM_CDN_PATH}/header/1b-m.jpg/1b-m.jpg`,
    title: t('header.title'),
    alt: t('header.title'),
  },
  {
    ldSrcSet: `${BATHROOM_CDN_PATH}/header/2b-ld.jpg/2b-ld.jpg`,
    dSrcSet: `${BATHROOM_CDN_PATH}/header/2c-d.jpg/2c-d.jpg`,
    tSrcSet: `${BATHROOM_CDN_PATH}/header/2b-t.jpg/2b-t.jpg`,
    mSrcSet: `${BATHROOM_CDN_PATH}/header/2b-m.jpg/2b-m.jpg`,
    title: t('header.title'),
    alt: t('header.title'),
  },
  {
    ldSrcSet: `${BATHROOM_CDN_PATH}/header/3b-ld.jpg/3b-ld.jpg`,
    dSrcSet: `${BATHROOM_CDN_PATH}/header/3c-d.jpg/3c-d.jpg`,
    tSrcSet: `${BATHROOM_CDN_PATH}/header/3b-t.jpg/3b-t-2.jpg`,
    mSrcSet: `${BATHROOM_CDN_PATH}/header/3b-m.jpg/3b-m-2.jpg`,
    title: t('header.title'),
    alt: t('header.title'),
  },
  {
    ldSrcSet: `${BATHROOM_CDN_PATH}/header/4b-ld.jpg/4b-ld-2.jpg`,
    dSrcSet: `${BATHROOM_CDN_PATH}/header/4c-d.jpg/4c-d.jpg`,
    tSrcSet: `${BATHROOM_CDN_PATH}/header/4b-t.jpg/4b-t-2.jpg`,
    mSrcSet: `${BATHROOM_CDN_PATH}/header/4b-m.jpg/4b-m.jpg`,
    title: t('header.title'),
    alt: t('header.title'),
  },
  {
    ldSrcSet: `${BATHROOM_CDN_PATH}/header/5b-ld.jpg/5b-ld-4.jpg`,
    dSrcSet: `${BATHROOM_CDN_PATH}/header/5c-d.jpg/5c-d-2.jpg`,
    tSrcSet: `${BATHROOM_CDN_PATH}/header/5b-t.jpg/5b-t-2.jpg`,
    mSrcSet: `${BATHROOM_CDN_PATH}/header/5b-m.jpg/5b-m.jpg`,
    title: t('header.title'),
    alt: t('header.title'),
  },
];
